import { render, staticRenderFns } from "./productInner.vue?vue&type=template&id=a2633b00&scoped=true"
import script from "./productInner.vue?vue&type=script&lang=js"
export * from "./productInner.vue?vue&type=script&lang=js"
import style0 from "./productInner.vue?vue&type=style&index=0&id=a2633b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2633b00",
  null
  
)

export default component.exports